export default {
  en: {
    loaderText:
      'The response time from the server is slow, check server and database load.',
    bottomText: 'Initializing, please wait',
  },
};
